import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getFinSadaad = createAsyncThunk("api/sadaad/list", async (token) => {
    try {
        const response = await nodeinstance.get('/sadaad/list', {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const FinSadaadListDataSlice = createSlice({
    name: "clientList",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFinSadaad.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getFinSadaad.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFinSadaad.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getFinSadaad };
export default FinSadaadListDataSlice.reducer;
